module.exports = __webpack_public_path__ + "img/2.d622d24e.jpg";